import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd';
import {_HttpClient} from '@delon/theme';
import {STColumn} from '@delon/abc';
import {STData} from '@delon/abc';
import {ContractEditorComponent} from '../contract-editor/contract-editor.component';
import {STComponent} from '@delon/abc';
import {ViewChild} from '@angular/core';
import {STReq} from '@delon/abc';
import {STRes} from '@delon/abc';
import {DrawerHelper} from '@delon/theme';
import {SystemContants} from '@core/constants';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styles: []
})
export class ContractListComponent implements OnInit {


  @Input()
  record: any = {};

  @ViewChild("stContract")
  stContract: STComponent;

  hideList: boolean = false;
  hideImage: boolean = true;

  currentContract: any = {};

  contractColumn: STColumn[] = [
    {title: '标题', index: 'title'},
    {title: '金额', index: 'amount'},
    {title: '开始时间', index: 'startTime'},
    {title: '结束时间', index: 'endTime'},
    {title: '创建人', index: 'creatorName'},
    {title: '创建时间', index: 'createTime'},
    {
      title: '操作',
      buttons: [
        {
          text: '原件管理',
          click: (record: STData) => {
            this.currentContract = record;
            this.hideList = true;
            this.hideImage = false;
          }
        },
        {
          text: '编辑',
          type: 'drawer',
          drawer: {
            component: ContractEditorComponent,
            title: '编辑合同'
          },
          click: 'reload'
        },
        {
          text: '删除',
          pop: true,
          popTitle: '确定要删除吗？',
          click: (record: STData) => {
            this.http.delete<any>('api/app/contract/id/'+record.id).subscribe((resp) => {
              if (resp.status === SystemContants.STATUS_SUCCESS) {
                this.stContract.reload();
              }
            })
          }
        }
      ]
    }
  ];
  contractUrl = null;
  stReq: STReq = {
    method: 'POST',
    body: {}
  };
  stRes: STRes = {
    reName: {list: 'data.records', total: 'data.total'}
  };


  constructor(private ref: NzModalRef, private http: _HttpClient, private drawHelper: DrawerHelper) { }

  ngOnInit() {
    this.contractUrl = 'api/app/contract/page';
    this.stReq.body = {unitId: this.record.id};
    this.stContract.req = this.stReq;
    this.stContract.reload();
  }

  /**
   * 新增合同
   */
  toNewContract() {
    this.drawHelper.create('新增合同', ContractEditorComponent, {record:{unitId: this.record.id}}).subscribe(val =>{
      this.stContract.reload();
    });
  }

  backToList() {
    this.hideImage = true;
    this.hideList = false;
    this.stContract.reload();
  }

}
